import * as event from './rest/event';
import * as eventCart from './rest/eventCart';
import * as search from './rest/search';
import * as split from './rest/split';
import * as language from './rest/language';
import * as subscription from './rest/subscription';
import * as order from './rest/order';
import * as orders from './rest/orders';
import * as promo from './rest/promo';
import * as service from './rest/service';
import * as mailSubscription from './rest/mail-subscription';
import * as refund from './rest/refund';
import * as pay from './rest/pay';
import * as cart from './rest/cart';
import * as bulkBuyTeacher from './rest/bulkBuyTeacher';
import * as bulkBuyStudent from './rest/bulkBuyStudent';
import request from './request';

/**
 * Объект который предоставляет запросы к Api
 * @name api
 */
export default {
  event,
  eventCart,
  search,
  split,
  language,
  subscription,
  order,
  orders,
  cart,
  promo,
  service,
  mailSubscription,
  refund,
  pay,
  bulkBuyTeacher,
  bulkBuyStudent,
};

export const makeRequest = (params) => request(params);
